import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Image as ChakraImage } from '@chakra-ui/react';
import { formatAssetsUrl } from '@whitbread-eos/utils';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ZIP_HOTEL = 'ZIP';
var HUB_HOTEL = 'HUB';
var NOT_PI_HOTEL_BRANDS = [ZIP_HOTEL, HUB_HOTEL];
export default function HotelBrandLogo(_ref) {
  var brand = _ref.brand,
    logos = _ref.logos;
  var isNotPiBrand = useMemo(() => checkIfIsNotPiBrand(brand), [brand]);
  return isNotPiBrand ? _jsx(Box, _objectSpread(_objectSpread({}, hotelBrandLogoWrapperStyles), {}, {
    "data-testid": "srp_hotel-brand-logo",
    children: _jsx(ChakraImage, {
      src: formatAssetsUrl(getBrandLogoURL(brand, logos)),
      alt: brand === 'HUB' ? 'hub' : 'zip'
    })
  })) : null;
}
export var checkIfIsNotPiBrand = brand => {
  return NOT_PI_HOTEL_BRANDS.includes(brand === null || brand === void 0 ? void 0 : brand.toUpperCase());
};
export var getBrandLogoURL = (brand, logos) => {
  if (brand === 'HUB') {
    return logos.hubLogo;
  }
  return brand === 'ZIP' ? logos.zipLogo : '';
};
var hotelBrandLogoWrapperStyles = {
  position: 'absolute',
  top: 'sm',
  left: 0
};